import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import './Dashcontents.css'
import whatisiq from "../../imgs/whatisiq.png";
import demo3d from "../../imgs/demo.png";
import practice3d from "../../imgs/practice3d.png";
import final3d from "../../imgs/finaltest.png";
import whyiq from "../../imgs/whyiq.png";
import aboutiq from "../../imgs/aboutiq.png";
import howparticipate from "../../imgs/howparticipate.png";
import anuualschedule from "../../imgs/anuualschedule.png";
import pattern from "../../imgs/pattern.png";
import awards from "../../imgs/awards.png";
import fees from "../../imgs/fees.png";
import practice from "../../imgs/practice.png";
import psyco from "../../imgs/psyco.png";
import Box from '../Box/Box';
import Secrowbox from '../Secrowbox/Secrowbox';

const Dashcontendts = () => {
    return (
        <div className="maincontent">
            <span className='heading2'>Test Section</span>
            <div  className='Dashcontents1'>
                <Box  background={"linear-gradient(179deg, var(--t1), var(--t1))"} head={"Demo Test"} img={<img src={demo3d} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t2), var(--t2))"} head={"Practice Test"} img={<img src={practice3d} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t3), var(--t3))"} head={"Main Test"} img={<img src={final3d} alt="" />} />
            </div>

            <span className='heading'>About IQ & INIQTEST</span>
            <div  className='Dashcontents'>
                <Box  background={"linear-gradient(179deg, var(--t1), var(--t1))"} head={"What is IQ?"} img={<img src={whatisiq} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t2), var(--t2))"} head={"Why to Test IQ?"} img={<img src={whyiq} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t3), var(--t3))"} head={"About INIQTEST"} img={<img src={aboutiq} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t4), var(--t4))"} head={"How to Participate"} img={<img src={howparticipate} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t5), var(--t5))"} head={"Annual Schedule"} img={<img src={anuualschedule} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t6), var(--t6))"} head={"Pattern of the Test"} img={<img src={pattern} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t3), var(--t3))"} head={"Awards/Rewards"} img={<img src={awards} alt="" />} />
                <Box background={"linear-gradient(179deg, var(--t4), var(--t4))"} head={"Fees/Pricing"} img={<img src={fees} alt="" />} />
            </div>
            <div className="secrow">
                <Secrowbox background={"linear-gradient(179deg, var(--t2), var(--t2)"} bname={"Practice Now"} title={"Practice to Brainstrom"} one={"Practice Tests"} two={"Solve different brain stimulating questions"} three={"to sharpen your brain."} img={<img src={practice} alt="" />} />

                <Secrowbox background={"linear-gradient(179deg, var(--t3), var(--t3)"} bname={"Know more"} title={"Counselling"} one={"Couselling"} two={"Counselling is just like therapy which allows"} three={"people to..."} img={<img src={psyco} alt="" />} />

                <Secrowbox background={"linear-gradient(179deg, var(--t4), var(--t4)"} bname={"Know more"} title={"Mentorship"} one={"Mentorship"} two={"Mentorship is a domain of counselling"} three={"that focuses..."} img={<img src={psyco} alt="" />} />


            </div>
        </div>
    )
}

export default Dashcontendts
